'use client'
import { Jumbotron as JumbotronData } from '@/payload-types'
import clsx from 'clsx'
import Image from 'next/image'
import ButtonComponent from '../button/button'
import { formatDate } from '@/lib/postFunctions'
import { useViewPort } from '@/utils/react-hooks/useViewPort'
import { useState, useEffect } from 'react'

interface IProps {
  jumbotronData?: JumbotronData
  rounded?: boolean
  publish?: string
}

export const Jumbotron = ({ jumbotronData, rounded, publish }: IProps) => {
  const jumbotron = jumbotronData
  const jumbotronStyle = jumbotronData?.styling
  const desktopImageUrl =
    typeof jumbotron?.media?.media === 'object'
      ? jumbotron.media.media?.sizes?.large?.url?.replace(/ /g, '%20')
      : ''
  const mobileImageUrl =
    typeof jumbotron?.media?.mobileMedia === 'object'
      ? jumbotron.media.mobileMedia?.sizes?.large?.url?.replace(/ /g, '%20')
      : ''

  const viewport = useViewPort()
  const [imageUrl, setImageUrl] = useState('')
  useEffect(() => {
    setImageUrl(
      viewport === 'mobile' &&
        jumbotronData?.media?.mobileMedia &&
        typeof jumbotronData.media.mobileMedia === 'object'
        ? mobileImageUrl || ''
        : desktopImageUrl || '',
    )
  }, [viewport, jumbotronData, mobileImageUrl, desktopImageUrl])

  return (
    <>
      <section
        className={clsx(
          'flex',
          'flex-col',
          'pb-10',
          'md:pb-20',
          'bg-center',
          'flex',
          'items-center',
          'bg-cover',
          'bg-no-repeat',
          'bg-blend-multiply',
          `${jumbotronStyle?.backgroundColor ? `bg-${jumbotronStyle?.backgroundColor}` : ''}`,
          `${rounded ? 'rounded-lg' : ''}`,
        )}
        style={
          typeof jumbotron?.media?.media === 'object' && jumbotron?.media?.position === 'fullWidth'
            ? {
                backgroundImage: `url('${
                  process.env.NEXT_PUBLIC_PAYLOAD_URL ? process.env.NEXT_PUBLIC_PAYLOAD_URL : ''
                }${imageUrl}')`,
              }
            : {}
        }
      >
        <div className={`pt-12 md:pt-32 px-4 mx-auto max-w-jumbotronWidth text-center  `}>
          <div
            className={`${
              jumbotron?.media?.position === 'rightHalf'
                ? 'grid gap-8 items-center mb-8 lg:mb-24 lg:gap-12 lg:grid-cols-12'
                : ''
            }`}
          >
            <div
              className={`${
                jumbotron?.media?.position === 'rightHalf'
                  ? 'col-span-6 text-center sm:mb-6 lg:text-left lg:mb-0'
                  : ''
              }`}
            >
              <h1
                className={clsx(
                  `md:mb-6 md:text-[45px] text-[30px] leading-[50px] tracking-tight font-extrabold text-${jumbotronStyle?.title?.color}`,
                )}
              >
                {jumbotron?.text.title}
              </h1>
              <p
                className={clsx(
                  `mb-8 text-lg font-semibold lg:text-xl ${
                    jumbotron?.media?.position === 'rightHalf' ? '' : 'sm:px-16 lg:px-8'
                  }  font-sans  text-${jumbotronStyle?.subTitle?.color}`,
                )}
              >
                {jumbotron?.text.subtitle}{' '}
              </p>
              <div
                className={`flex flex-row items-center justify-center ${
                  jumbotron?.media?.position === 'rightHalf'
                    ? 'lg:justify-start  xl:justify-start'
                    : ''
                }`}
              >
                {jumbotron?.buttons?.actionButton1?.selectedButtons && (
                  <ButtonComponent
                    buttonData={jumbotron?.buttons?.actionButton1.selectedButtons}
                    label={`${jumbotron.buttons.actionButton1.label}`}
                    url={`${jumbotron.buttons.actionButton1.url}`}
                    buttonCSS={' border border-white'}
                  />
                )}
                {jumbotron?.buttons?.actionButton2?.selectedButtons && (
                  <ButtonComponent
                    buttonData={jumbotron.buttons.actionButton2.selectedButtons}
                    label={`${jumbotron.buttons.actionButton2.label}`}
                    url={`${jumbotron.buttons.actionButton2.url}`}
                    buttonCSS={' border border-white'}
                  />
                )}
              </div>
            </div>

            {jumbotron?.media?.media && jumbotron.media.position === 'rightHalf' && (
              <div className="col-span-6">
                {typeof jumbotron.media.media === 'object' && (
                  <Image
                    src={`${
                      process.env.NEXT_PUBLIC_PAYLOAD_URL ? process.env.NEXT_PUBLIC_PAYLOAD_URL : ''
                    }${imageUrl}`}
                    width={20}
                    height={20}
                    alt={`${jumbotron.media.media.title}`}
                    className="mt-3"
                  />
                )}
              </div>
            )}
          </div>
        </div>
        {publish && (
          <div
            className={`text-${jumbotronStyle?.subTitle?.color} text-center md:my-4 font-semibold text-[16px]	`}
          >
            {formatDate(publish)}
          </div>
        )}
      </section>
    </>
  )
}

export default Jumbotron
